/**
 * `?next=` handling for the unified login.
 *
 * An auth screen is the worst place for an open redirect, so `next` is
 * accepted only as an internal, same-origin, path-only value.
 */
export function sanitizeNext(raw: string | null | undefined): string | null {
  if (!raw) return null;
  let value = raw.trim();
  if (!value.startsWith("/")) return null;
  // "//host" and "/\host" are protocol-relative — treat as external.
  if (value.startsWith("//") || value.startsWith("/\\")) return null;
  if (value.includes("\n") || value.includes("\r")) return null;
  // Never bounce back into the login screen itself.
  if (value === "/login" || value.startsWith("/login?")) return null;
  return value;
}

/** Default staff `next` values that a higher-privilege landing may override. */
const SOFT_STAFF_NEXT = new Set(["/admin", "/admin/dashboard"]);

export function resolveLanding(opts: {
  next: string | null;
  isSuperAdmin: boolean;
  isAdmin: boolean;
}): string {
  const { next, isSuperAdmin, isAdmin } = opts;
  if (next && !(isSuperAdmin && SOFT_STAFF_NEXT.has(next))) return next;
  if (isSuperAdmin) return "/platform";
  if (isAdmin) return "/admin/dashboard";
  return "/account";
}
